const CLASS_NAME = 'connect-line';
const getBounding = (element) => {
  if (Array.isArray(element)) {
    // 複数の要素から最大のDOMRectを作成
    const rects = element.map((el) => el.getBoundingClientRect());
    const minX = Math.min(...rects.map((rect) => rect.left));
    const minY = Math.min(...rects.map((rect) => rect.top));
    const maxX = Math.max(...rects.map((rect) => rect.right));
    const maxY = Math.max(...rects.map((rect) => rect.bottom));
    return {
      left: minX,
      top: minY,
      right: maxX,
      bottom: maxY,
      width: maxX - minX,
      height: maxY - minY,
    };
  }
  return element.getBoundingClientRect();
};
const getOffsetX = (rect, offset) => {
  if (offset === 'center') {
    return (rect.left - rect.right) * 0.5;
  }
  return Number(offset);
};
const getOffsetY = (rect, offset) => {
  if (offset === 'center') {
    return (rect.bottom - rect.top) * 0.5;
  }
  return Number(offset);
};
const connectElements = (startElement, endElement, options = {}) => {
  const startRect = getBounding(startElement);
  const endRect = getBounding(endElement);
  const startBasePosition = options.start?.basePosition || 'center';
  const endBasePosition = options.end?.basePosition || 'center';
  const startOffsetX = getOffsetX(startRect, options.start?.offset.x || 0);
  const startOffsetY = getOffsetY(startRect, options.start?.offset.y || 0);
  const endOffsetX = getOffsetX(endRect, options.end?.offset.x || 0);
  const endOffsetY = getOffsetY(endRect, options.end?.offset.y || 0);
  const startOffset = getOffset(startBasePosition, startRect, startOffsetX, startOffsetY);
  const endOffset = getOffset(endBasePosition, endRect, endOffsetX, endOffsetY);
  const startX = startOffset.x + window.scrollX;
  const startY = startOffset.y + window.scrollY;
  const endX = endOffset.x + window.scrollX;
  const endY = endOffset.y + window.scrollY;
  const borderStyle = options.borderStyle || 'solic';
  const borderOpacity = options.borderOpacity || 1.0;
  const borderWidth = options.borderWidth || 3;
  const borderLineCap = options.borderLineCap || 'round';
  const borderLineJoin = options.borderLineJoin || 'round';
  const dotSize = options.dotSize || 0;
  const padding = dotSize * 0.5;
  const minX = Math.min(startX, endX) - padding - borderWidth;
  const minY = Math.min(startY, endY) - padding - borderWidth;
  const maxX = Math.max(startX, endX) + padding + borderWidth;
  const maxY = Math.max(startY, endY) + padding + borderWidth;
  const width = maxX - minX;
  const height = maxY - minY;

  // Canvas
  /* eslint-disable */
  const editor = window.editor;
  const canvas = document.createElement('canvas');
  canvas.className = CLASS_NAME;
  canvas.style.position = 'absolute';
  canvas.style.left = `${minX}px`;
  canvas.style.top = `${minY}px`;
  canvas.width = width;
  canvas.height = height;
  canvas.style.zIndex = `${options.zIndex || 999}`;
  canvas.addEventListener('mouseenter', () => {
    const elements = document.querySelectorAll(`.${CLASS_NAME}`);
    [].forEach.call(elements, (el) => {
      if (el && el instanceof HTMLElement) {
        el.style.display = 'none';
      }
    });
    setTimeout(() => {
      [].forEach.call(elements, (el) => {
        if (el && el instanceof HTMLElement) {
          el.style.display = 'block';
        }
      });
    }, 1000);
  });
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  ctx.beginPath();
  ctx.setLineDash(borderStyle === 'dashed' ? [5, 5] : []);
  ctx.lineWidth = borderWidth;
  ctx.strokeStyle = options.borderColor || '#813b01';
  ctx.globalAlpha = borderOpacity;
  ctx.lineCap = borderLineCap;
  ctx.lineJoin = borderLineJoin;
  ctx.moveTo(startX - minX, startY - minY);
  ctx.lineTo(endX - minX, endY - minY);
  ctx.stroke();
  ctx.setLineDash([]);

  const startWithDot = options.start?.withDot || false;
  const endWithDot = options.end?.withDot || false;
  if (startWithDot || endWithDot) {
    ctx.beginPath();
    ctx.fillStyle = options.borderColor || '#813b01';
    if (startWithDot) {
      // 丸の描画 (開始点)
      ctx.arc(startX - minX, startY - minY, dotSize / 2, 0, Math.PI * 2);
      ctx.fill();
    }
    if (endWithDot) {
      // 丸の描画 (終了点)
      ctx.arc(endX - minX, endY - minY, dotSize / 2, 0, Math.PI * 2);
      ctx.fill();
    }
  }
};
const getOffset = (basePosition, rect, offsetX, offsetY) => {
  const offsets = {
    topLeft: {
      x: rect.left + offsetX,
      y: rect.top + offsetY,
    },
    topRight: {
      x: rect.right + offsetX,
      y: rect.top + offsetY,
    },
    bottomLeft: {
      x: rect.left + offsetX,
      y: rect.bottom + offsetY,
    },
    bottomRight: {
      x: rect.right + offsetX,
      y: rect.bottom + offsetY,
    },
    center: {
      x: rect.left + rect.width / 2 + offsetX,
      y: rect.top + rect.height / 2 + offsetY,
    },
  };
  return offsets[basePosition];
};
const clearConnectElements = () => {
  const elements = document.querySelectorAll(`.${CLASS_NAME}`);
  [].forEach.call(elements, (el) => {
    el.remove();
  });
};

export { clearConnectElements, connectElements };
